/**
 * Item 515 — o que fazer com um evento de mensagem.
 *
 * O socket do simulador recebe os eventos do tenant inteiro, e o evento não diz de QUEM é a conversa.
 * Antes, com a tela sem conversa, o primeiro evento a definia — e podia ser de outro cliente.
 *
 * - `sync` — é a conversa que a tela já mostra: busca as mensagens.
 * - `ask-owner` — conversa desconhecida: só vira a da tela se o engine disser que é a conversa mais
 *   recente DESTE cliente (`channelIdentifier`). Cobre a IA que fala primeiro (tela ainda sem
 *   conversa) e a conversa nova do mesmo cliente depois de uma encerrada.
 */
export type EventConversationAction =
  | { readonly kind: 'sync'; readonly conversationId: string }
  | { readonly kind: 'ask-owner'; readonly conversationId: string };

export function actionForEvent(
  current: string | null,
  eventConversationId: string,
): EventConversationAction {
  if (current !== null && eventConversationId === current) {
    return { kind: 'sync', conversationId: current };
  }
  return { kind: 'ask-owner', conversationId: eventConversationId };
}

/** A conversa do evento é a do cliente? Só com a resposta do engine em mãos; falha ⇒ não. */
export function isOwnConversation(
  ownConversationId: string | null,
  eventConversationId: string,
): boolean {
  return ownConversationId !== null && ownConversationId === eventConversationId;
}
